import { render, staticRenderFns } from "./FaultComparisson.vue?vue&type=template&id=272943ea&"
import script from "./FaultComparisson.vue?vue&type=script&lang=js&"
export * from "./FaultComparisson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports